/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CrmLeadKanbanBody from "components/CRMComponents/CRMLeadListComponents/CrmLeadKanbanBody/CrmLeadKanbanBody";

const CrmLeadKanban = () => {
  useEffect(() => {
    document.title = "CRM Lead Kanban";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <CrmLeadKanbanBody />
    </main>
  );
};

export default CrmLeadKanban;
